var exports = {
  "OT": "RebasingStacksSection__P2xdOT",
  "Dg": "RebasingStacksSectionSpinner__KtNdON",
  "JI": "RebasingStacksSectionFooter__-hExRw",
};

module.exports = exports;
